export class PlusEnvironment {
  public static getName = () => 'benzinga-plus';
  public static getEnvironment = (env: Record<string, string>) => ({
    token: env.token ?? 'db64a8e114b8810f7ef55604c66cc20d4ec0474d53c597dd68ff434d5d94fa5e',
    url: new URL(env.url ?? 'https://www.benzinga.com/research/api/'),
  });
}
